/**
 * custom.js - ARTWORKS KOBE カスタムスクリプト
 * theme.liquid の </body> 直前に以下を追加して読み込む:
 * <script src="{{ 'custom.js' | asset_url }}" defer></script>
 */

// ============================================================
// 1. オリジナルウェアページの参考価格注意書き表示
// ============================================================
function priceAttentionAdd() {
  if (!window.location.href.includes("/pages/original")) return;

  const notice = document.createElement("p");
  notice.textContent =
    "表示価格は参考価格です。ビッグサイズや特殊な生地色などにより金額が異なりますので、正式な価格はお見積もりをご依頼ください。";
  notice.style.cssText =
    "text-align:center; font-size:16px; color:coral; border:1px solid coral; padding:0.5rem 1rem; margin-bottom:0.5rem";

  const target = document.getElementById("order")?.nextElementSibling;
  if (target) target.append(notice);
}

// ============================================================
// 1.5. 既製品ページ → シミュレーター（同じデザインでチームウェア）のバナー
//   同じデザイン・同じ素材・ブラックの生地にデザインを置いた状態でシミュレーターが開く。
//   受け側は tee-mockup の lib/shop-link.ts（?from=商品ハンドル）。
//   addOtherItemList() より後に呼ぶこと（両方とも同じ場所の先頭に差し込むため、
//   後に呼んだ方が上に表示される。バナーをリストより上に出したいので後）。
// ============================================================
function addSimulatorBanner() {
  const isAwRegularItem = /aw-[\w]{3}/.test(document.location.href);
  if (!isAwRegularItem) return;
  if (/omo|nkn/.test(location.pathname)) return;

  // 商品ハンドル（例 aw-spt1003-ns-dry）。addOtherItemList と同じ切り出し
  const thisPageSku = location.pathname.match(/aw-[\w]{3}[\d]{4}-[\w]*-[\w]*/);
  if (!thisPageSku) return;

  const SIMULATOR_URL = "https://aw-images.artworks-kobe.com/simulator/";
  const url = SIMULATOR_URL + "?from=" + encodeURIComponent(thisPageSku[0]);

  const container = document.createElement("div");
  container.className = "aw-simulator-banner";

  // バナー上部のキャッチコピー
  const catchCopy = document.createElement("p");
  catchCopy.textContent = "＼チーム・個人用にカスタムしませんか？／";
  catchCopy.style.cssText =
    "text-align:center; font-weight:bold; font-size:16px; margin:0 0 6px;";

  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener";
  a.setAttribute(
    "aria-label",
    "このデザインでチームウェアを作る（シミュレーターを開く）",
  );

  // バナー画像。src は後から手で入れる（空のままだとブラウザは何も読みに行かない）
  const img = document.createElement("img");
  img.src =
    "https://aw-images.artworks-kobe.com/simulator/banner/banner_aw-simulator.jpg";
  img.alt =
    "このデザインでチームウェアが作れます。チーム名や個人名を入れて、好きなデザインを作ろう";
  img.loading = "lazy";
  img.style.maxWidth = "100%";
  img.style.height = "auto";
  img.style.display = "block";

  a.appendChild(img);

  // バナー下部の説明（少し小さめ）
  const points = document.createElement("ul");
  points.style.cssText =
    "font-size:13px; line-height:1.6; margin:6px 0 0; padding-left:1.4em;";
  [
    "生地の種類変更も可能！",
    "チーム名や個人名が入れることもできます。",
    "デザインを変えると金額が自動表示。",
    "そのまま注文まで進めます！",
  ].forEach((text) => {
    const li = document.createElement("li");
    li.textContent = text;
    points.appendChild(li);
  });

  container.appendChild(catchCopy);
  container.appendChild(a);
  container.appendChild(points);

  const targetObj = document.querySelector(
    ".product__description.rte.quick-add-hidden",
  );
  if (targetObj) targetObj.insertBefore(container, targetObj.firstChild);
}

// ============================================================
// 2. 同じデザインの別素材リンクリストを商品ページに表示
// ============================================================
function addOtherItemList() {
  const isAwRegularItem = /aw-[\w]{3}/.test(document.location.href);
  if (!isAwRegularItem) return;
  if (/omo|nkn/.test(location.pathname)) return;

  const thisPageSku = location.pathname.match(/aw-[\w]{3}[\d]{4}-[\w]*-[\w]*/);
  if (!thisPageSku) return;

  const itemCategory = thisPageSku[0].match(
    /ts-dry|ns-dry|tsl-dry|tr-pil|pp-pil|zp-pil/,
  );
  if (!itemCategory) return;

  const productBaseURL = location.origin + "/products/";
  const variations = [
    { slug: "ts-dry", name: "半袖ドライTシャツ" },
    { slug: "ns-dry", name: "ノースリーブシャツ" },
    { slug: "tsl-dry", name: "長袖ドライTシャツ" },
    { slug: "tr-pil", name: "トレーナー" },
    { slug: "pp-pil", name: "プルオーバーパーカー" },
    { slug: "zp-pil", name: "ジップパーカー" },
  ];

  const container = document.createElement("div");
  const heading = document.createElement("h4");
  heading.textContent = "▼同じデザインで他の素材もあります";
  const list = document.createElement("ul");

  variations.forEach(({ slug, name }) => {
    if (slug === itemCategory[0]) return; // 現在の素材はスキップ
    const url = productBaseURL + thisPageSku[0].replace(itemCategory[0], slug);
    const li = document.createElement("li");
    const a = document.createElement("a");
    a.href = url;
    a.innerText = name;
    li.appendChild(a);
    list.appendChild(li);
  });

  container.appendChild(heading);
  container.appendChild(list);

  const targetObj = document.querySelector(
    ".product__description.rte.quick-add-hidden",
  );
  if (targetObj) targetObj.insertBefore(container, targetObj.firstChild);
}

// ============================================================
// 3. 価格を bold_option_set の直後に再表示
// ============================================================
(function () {
  const ESTIMATE_BANNER_ID = "awk-estimate-banner";
  const ONE_TO_FOUR_NOTICE_ID = "awk-one-to-four-notice";

  const estimateBannerImageUrl =
    "https://cdn.shopify.com/s/files/1/0406/3920/1439/files/banner-estimate-tshirt.jpg";

  const estimateBannerLinkUrl = "https://estimate.artworks-kobe.com/";

  function getProductTitle() {
    return document.querySelector("h1")?.textContent?.trim() || "";
  }

  function isUniformProduct() {
    return getProductTitle().includes("ユニフォーム");
  }

  function isOritProduct() {
    return /^\/products\/orit/i.test(window.location.pathname);
  }

  function isOneToFourProduct() {
    return /^\/products\/orit[^/]*-1\/?$/i.test(window.location.pathname);
  }

  function getQuantityInsertTarget() {
    const quantityRules = document.querySelector(
      '.quantity__rules.caption[id^="Quantity-Rules-"]',
    );

    if (!quantityRules) return null;

    return quantityRules.parentElement || quantityRules;
  }

  function hideDuplicateQuantityRangeTitles() {
    if (!isOritProduct()) return true;

    const titles = [...document.querySelectorAll(".bold_option_title")].filter(
      (title) => title.textContent.includes("ご希望枚数の範囲"),
    );

    if (titles.length <= 1) return titles.length === 1;

    // ボタンが入っている本物の「ご希望枚数の範囲」を残す
    const keepTitle =
      titles.find((title) => {
        const option = title.closest(".bold_option");
        const text = option?.textContent || "";

        return /1[〜～~\-−]4枚|5[〜～~\-−]19枚|20[〜～~\-−]49枚|50[〜～~\-−]99枚|100枚以上/.test(
          text,
        );
      }) || titles[titles.length - 1];

    titles.forEach((title) => {
      if (title !== keepTitle) {
        title.style.display = "none";
        title.setAttribute("data-awk-hidden-duplicate", "true");
      }
    });

    return true;
  }

  function insertEstimateBanner() {
    if (!isOritProduct()) return true;

    // h1がまだ読み込まれていない場合は待つ
    if (!getProductTitle()) return false;

    // h1に「ユニフォーム」が入っていたら自動見積バナーは出さない
    if (isUniformProduct()) return true;

    if (document.getElementById(ESTIMATE_BANNER_ID)) return true;

    const target = getQuantityInsertTarget();
    if (!target) return false;

    const banner = document.createElement("div");
    banner.id = ESTIMATE_BANNER_ID;
    banner.className = "awk-estimate-banner";

    banner.innerHTML = `
      <a href="${estimateBannerLinkUrl}" target="_blank" rel="noopener">
        <img src="${estimateBannerImageUrl}" alt="オリジナルウェアの自動見積り" loading="lazy">
      </a>
    `;

    target.insertAdjacentElement("afterend", banner);

    return true;
  }

  function insertNoticeForOneToFourOrders() {
    // Canva文言は -1 商品だけ
    if (!isOneToFourProduct()) return true;

    // h1がまだ読み込まれていない場合は待つ
    if (!getProductTitle()) return false;

    // ユニフォーム商品にはCanva文言も出さない
    if (isUniformProduct()) return true;

    if (document.getElementById(ONE_TO_FOUR_NOTICE_ID)) return true;

    const notice = document.createElement("div");
    notice.id = ONE_TO_FOUR_NOTICE_ID;
    notice.className = "one-to-four-notice";

    notice.innerHTML = `
      <span>
        1〜4枚をご注文のお客様は、Canvaでのデータ入稿のみ制作可能です。<br>
        <a href="https://artworks-kobe.com/pages/canva" target="_blank" rel="noopener">
          Canvaについてはこちらのページをご確認ください。
        </a>
      </span>
    `;

    const banner = document.getElementById(ESTIMATE_BANNER_ID);

    if (banner) {
      banner.insertAdjacentElement("afterend", notice);
      return true;
    }

    const target = getQuantityInsertTarget();

    if (target) {
      target.insertAdjacentElement("afterend", notice);
      return true;
    }

    return false;
  }

  function addStyle() {
    if (document.getElementById("awk-product-custom-style")) return;

    const style = document.createElement("style");
    style.id = "awk-product-custom-style";

    style.textContent = `
      .awk-estimate-banner {
        margin: 18px 0 24px;
      }

      .awk-estimate-banner a {
        display: block;
        transition: opacity 0.2s ease;
      }

      .awk-estimate-banner a:hover {
        opacity: 0.86;
      }

      .awk-estimate-banner img {
        display: block;
        width: 100%;
        max-width: 560px;
        height: auto;
        border-radius: 8px;
      }

      .one-to-four-notice {
        margin: 16px 0 20px;
        padding: 12px 14px;
        background: #f7f7f7;
        border-left: 4px solid #222;
        font-size: 14px;
        line-height: 1.7;
      }

      .one-to-four-notice a {
        color: #0066cc;
        text-decoration: underline;
      }
    `;

    document.head.appendChild(style);
  }

  function run() {
    hideDuplicateQuantityRangeTitles();
    insertEstimateBanner();
    insertNoticeForOneToFourOrders();
  }

  function init() {
    if (!isOritProduct()) return;

    addStyle();

    let count = 0;
    const maxCount = 40;

    const timer = setInterval(function () {
      run();
      count++;

      if (count >= maxCount) {
        clearInterval(timer);
      }
    }, 300);

    // Bold Optionsが後から再描画しても、重複タイトルを再度消す
    const observer = new MutationObserver(function () {
      run();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// ============================================================
// 5. Canva案内のスタイル注入
// ============================================================
function injectOneToFourNoticeStyle() {
  const style = document.createElement("style");
  style.textContent = `
    .one-to-four-notice {
      white-space: normal !important;
      margin: 0;
      line-height: 1.3;
      color: red;
      font-weight: bold;
    }
    .one-to-four-notice a {
      color: blue;
    }
  `;
  document.head.appendChild(style);
}

// ============================================================
// 初期化 - DOM構築完了後に全関数を実行
// ============================================================
document.addEventListener("DOMContentLoaded", () => {
  priceAttentionAdd();
  addOtherItemList();
  addSimulatorBanner(); // リストより後に呼ぶ＝バナーが先頭（上）に来る
  // insertNoticeForOneToFourOrders() はここでは呼ばない：
  // 上のIIFE(制作ヒント/見積りバナー)内で init→run から実行済み（スコープもIIFEローカル）。
  // ここから呼ぶと未定義参照になり、後続の injectOneToFourNoticeStyle まで止まる。
  injectOneToFourNoticeStyle();
});

/* ============================================================
   制作実績ハブ（/pages/works）コントローラ
   本番は assets/aw-base.js の末尾に追記する。
   - ページ内の .aw-works-tile（静的HTML）を読み、競技フィルタ・
     詳細モーダル・案件送り（モーダル全体の透明な左右矢印）・
     案件内の複数画像（指に追従するドラッグ式カルーセル＋メイン下のサムネイル）を動かす。
   - 実績の追加＝ページHTMLに .aw-works-tile を1個足すだけ（JSは触らない）。
   - 全体をIIFEで包みグローバルを汚さない＝既存関数と衝突しない。
   - 対象要素が無いページでは即return（全ページ読み込みでも無害）。
   ============================================================ */
(function () {
  var grid = document.getElementById("aw-works-grid");
  var modal = document.getElementById("aw-works-modal");
  if (!grid || !modal) return; // 実績ハブ以外のページでは何もしない

  // テーマがページ本文(.rte.scroll-trigger 等)に transform をかけていると、
  // その中の position:fixed は画面基準にならず親要素基準になり、モーダルが画面外へ飛ぶ。
  // モーダルを body 直下へ逃がして、確実に画面全体へ固定表示させる（HTMLの置き場所に依存しない）。
  if (modal.parentNode !== document.body) document.body.appendChild(modal);

  var filterBox = document.getElementById("aw-works-filter");
  var tiles = []; // init() で確定（外部取り込みの場合は取り込み後に確定）

  var elSport = modal.querySelector(".aw-works-sport");
  var elTeam = modal.querySelector(".aw-works-team");
  var elMat = modal.querySelector('[data-field="material"]');
  var elQty = modal.querySelector('[data-field="qty"]');
  var elPrice = modal.querySelector('[data-field="price"]');
  var elCta = modal.querySelector(".aw-works-cta");
  var elPcount = modal.querySelector(".aw-works-pcount");
  var elThumbs = modal.querySelector(".aw-works-thumbs");
  var media = modal.querySelector(".aw-works-media");
  var elTrack = modal.querySelector(".aw-works-track");
  var pnavPrev = modal.querySelector(".aw-works-pnav-prev");
  var pnavNext = modal.querySelector(".aw-works-pnav-next");
  var box = modal.querySelector(".aw-works-modal-box");
  var dragBar = modal.querySelector(".aw-works-drag");

  var viewList = []; // 現在の絞り込みで表示中のタイル要素の並び
  var viewPos = -1; // viewList 内の現在位置
  var imgs = []; // 現在の案件の画像URL配列
  var imgIdx = 0;
  var curTeam = "";

  function tileData(tile) {
    return {
      sport: tile.getAttribute("data-sport") || "",
      team: tile.getAttribute("data-team") || "",
      material: tile.getAttribute("data-material") || "",
      qty: tile.getAttribute("data-qty") || "",
      price: tile.getAttribute("data-price") || "",
      url: tile.getAttribute("data-url") || "#",
      images: (tile.getAttribute("data-images") || "")
        .split("|")
        .filter(Boolean),
    };
  }

  /* --- 競技フィルタ --- */
  function applyFilter(sport) {
    viewList = [];
    tiles.forEach(function (tile) {
      var show =
        !sport ||
        sport === "すべて" ||
        tile.getAttribute("data-sport") === sport;
      tile.hidden = !show;
      if (show) viewList.push(tile);
    });
  }

  function buildFilter() {
    if (!filterBox) return;
    var sports = ["すべて"];
    tiles.forEach(function (t) {
      var s = t.getAttribute("data-sport");
      if (s && sports.indexOf(s) < 0) sports.push(s);
    });
    sports.forEach(function (s, i) {
      var b = document.createElement("button");
      b.type = "button";
      b.textContent = s;
      if (i === 0) b.className = "is-active";
      b.addEventListener("click", function () {
        [].forEach.call(filterBox.children, function (c) {
          c.classList.remove("is-active");
        });
        b.classList.add("is-active");
        applyFilter(s);
      });
      filterBox.appendChild(b);
    });
  }

  /* --- 案件内の画像カルーセル --- */
  function buildSlides() {
    elTrack.innerHTML = "";
    imgs.forEach(function (src) {
      var slide = document.createElement("div");
      slide.className = "aw-works-slide";
      var im = document.createElement("img");
      im.setAttribute("src", src);
      im.setAttribute("alt", curTeam);
      im.setAttribute("draggable", "false");
      slide.appendChild(im);
      elTrack.appendChild(slide);
    });
  }

  // メイン画像の下に並ぶサムネイル列（クリック/タップで該当画像へ切替）
  function buildThumbs() {
    elThumbs.innerHTML = "";
    if (imgs.length <= 1) {
      elThumbs.hidden = true; // 1枚のときは列ごと非表示
      return;
    }
    elThumbs.hidden = false;
    imgs.forEach(function (src, i) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "aw-works-thumb";
      b.setAttribute("aria-label", i + 1 + "枚目を表示");
      var im = document.createElement("img");
      im.setAttribute("src", src);
      im.setAttribute("alt", "");
      im.setAttribute("draggable", "false");
      b.appendChild(im);
      b.addEventListener("click", function () {
        imgIdx = i;
        paintImg();
      });
      elThumbs.appendChild(b);
    });
  }

  function syncThumbs() {
    [].forEach.call(elThumbs.children, function (b, i) {
      b.classList.toggle("is-active", i === imgIdx);
    });
  }

  // トラックを現在の画像位置へ。animate=false なら即時、true なら滑らかに。
  function setTrack(animate) {
    elTrack.style.transition = animate ? "transform 0.28s ease" : "none";
    elTrack.style.transform = "translateX(" + -imgIdx * 100 + "%)";
  }

  function paintImg() {
    imgIdx = Math.max(0, Math.min(imgIdx, imgs.length - 1)); // 端でループしない
    setTrack(true);
    syncThumbs();
  }

  /* --- 1案件ぶんの中身を流し込む --- */
  function fill(tile) {
    var d = tileData(tile);
    var thumb = tile.querySelector("img");
    imgs = d.images.length
      ? d.images
      : [thumb ? thumb.getAttribute("src") : ""];
    imgIdx = 0;
    curTeam = d.team;
    elSport.textContent = d.sport;
    elTeam.textContent = d.team;
    elMat.textContent = d.material;
    elQty.textContent = d.qty;
    elPrice.textContent = d.price;
    elCta.setAttribute("href", d.url);
    buildSlides();
    buildThumbs();
    setTrack(false); // 案件切替時はアニメなしで先頭画像へ
    syncThumbs();
    updateProjectNav();
  }

  /* --- 案件位置の表示と端での矢印無効化 --- */
  function updateProjectNav() {
    var n = viewList.length;
    elPcount.textContent = viewPos + 1 + " / " + n + "件";
    pnavPrev.disabled = viewPos <= 0;
    pnavNext.disabled = viewPos >= n - 1;
  }

  function openModal(tile) {
    viewPos = viewList.indexOf(tile);
    fill(tile);
    resetBoxPos(); // 前回ドラッグした位置を中央に戻してから開く
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    // 背後のページはスクロール可のまま（body の overflow は固定しない）
  }
  function closeModal() {
    // 閉じる前に、モーダル内に残ったフォーカスを外す
    // （フォーカス保持要素に aria-hidden を付けると a11y 警告が出るため）
    if (modal.contains(document.activeElement)) document.activeElement.blur();
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
  }
  function gotoProject(step) {
    var np = viewPos + step;
    if (np < 0 || np >= viewList.length) return;
    viewPos = np;
    fill(viewList[viewPos]);
  }

  /* --- イベント --- */
  grid.addEventListener("click", function (e) {
    var t = e.target.closest(".aw-works-tile");
    if (t) openModal(t);
  });
  pnavPrev.addEventListener("click", function () {
    gotoProject(-1);
  });
  pnavNext.addEventListener("click", function () {
    gotoProject(1);
  });
  modal.addEventListener("click", function (e) {
    if (e.target.hasAttribute("data-close")) closeModal();
  });
  document.addEventListener("keydown", function (e) {
    if (!modal.classList.contains("is-open")) return;
    if (e.key === "Escape") closeModal();
    else if (e.key === "ArrowLeft") gotoProject(-1);
    else if (e.key === "ArrowRight") gotoProject(1);
  });

  /* --- 案件内の画像：指に追従するドラッグ式カルーセル --- */
  var dragX = 0,
    dragY = 0,
    dragging = false,
    horiz = null,
    mediaW = 1;

  media.addEventListener(
    "touchstart",
    function (e) {
      if (imgs.length <= 1) return;
      var t = e.changedTouches[0];
      dragX = t.clientX;
      dragY = t.clientY;
      dragging = true;
      horiz = null;
      mediaW = media.clientWidth || 1;
      elTrack.style.transition = "none";
    },
    { passive: true },
  );
  media.addEventListener(
    "touchmove",
    function (e) {
      if (!dragging) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - dragX;
      var dy = t.clientY - dragY;
      // 最初の動きで横方向か縦方向かを判定（縦は通常のスクロールに任せる）
      if (horiz === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
        horiz = Math.abs(dx) > Math.abs(dy);
      }
      if (horiz) {
        e.preventDefault(); // 横ドラッグ中はページスクロールを止める
        // 端では抵抗を付けて引っ張りすぎないように
        if (
          (imgIdx === 0 && dx > 0) ||
          (imgIdx === imgs.length - 1 && dx < 0)
        ) {
          dx *= 0.35;
        }
        elTrack.style.transform =
          "translateX(calc(" + -imgIdx * 100 + "% + " + dx + "px))";
      }
    },
    { passive: false },
  );
  media.addEventListener(
    "touchend",
    function (e) {
      if (!dragging) return;
      dragging = false;
      if (!horiz) return;
      var dx = e.changedTouches[0].clientX - dragX;
      var thresh = Math.max(40, mediaW * 0.18);
      if (dx <= -thresh && imgIdx < imgs.length - 1) imgIdx++;
      else if (dx >= thresh && imgIdx > 0) imgIdx--;
      paintImg(); // 確定位置へ滑らかにスナップ
    },
    { passive: true },
  );

  /* --- スマホ：上部つまみバーで窓ごと移動（指に追従。はみ出した部分を寄せる） --- */
  var boxOffX = 0,
    boxOffY = 0;

  function applyBoxTransform() {
    box.style.transform =
      boxOffX || boxOffY
        ? "translate(" + boxOffX + "px," + boxOffY + "px)"
        : "";
  }
  function resetBoxPos() {
    boxOffX = 0;
    boxOffY = 0;
    applyBoxTransform();
  }

  if (dragBar) {
    var bStartX = 0,
      bStartY = 0,
      bBaseX = 0,
      bBaseY = 0,
      bDragging = false;

    dragBar.addEventListener(
      "touchstart",
      function (e) {
        var t = e.changedTouches[0];
        bStartX = t.clientX;
        bStartY = t.clientY;
        bBaseX = boxOffX;
        bBaseY = boxOffY;
        bDragging = true;
      },
      { passive: true },
    );
    dragBar.addEventListener(
      "touchmove",
      function (e) {
        if (!bDragging) return;
        e.preventDefault(); // ページスクロールに奪われないように
        var t = e.changedTouches[0];
        boxOffX = bBaseX + (t.clientX - bStartX);
        boxOffY = bBaseY + (t.clientY - bStartY);
        applyBoxTransform();
      },
      { passive: false },
    );
    dragBar.addEventListener(
      "touchend",
      function () {
        bDragging = false;
      },
      { passive: true },
    );
  }

  // タイルが出揃ってから初期化（フィルタ生成＋初期表示）。
  function init() {
    tiles = [].slice.call(grid.querySelectorAll(".aw-works-tile"));
    buildFilter();
    applyFilter("すべて");
  }

  /* --- 実績データは works ページ1か所で管理し、競技ページは自動追従 ---
     grid が data-works-src を持ち、かつ自前のタイルを持たないときだけ、
     その URL（例: /pages/works）を取得して data-works-sport に一致する
     タイルだけを取り込む。works ページ自身は静的タイルを持つので取得しない。 */
  var worksSrc = grid.getAttribute("data-works-src");
  var worksSport = grid.getAttribute("data-works-sport");
  // data-works-sport はカンマ区切りで複数競技を指定可（例: "陸上競技,マラソン"）。空なら全件。
  var wantSports = worksSport
    ? worksSport
        .split(",")
        .map(function (s) {
          return s.trim();
        })
        .filter(Boolean)
    : null;
  if (worksSrc && !grid.querySelector(".aw-works-tile")) {
    fetch(worksSrc, { credentials: "same-origin" })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var srcTiles = doc.querySelectorAll("#aw-works-grid .aw-works-tile");
        [].forEach.call(srcTiles, function (t) {
          if (
            !wantSports ||
            wantSports.indexOf(t.getAttribute("data-sport")) >= 0
          ) {
            grid.appendChild(document.importNode(t, true)); // 別ドキュメントから複製して取り込む
          }
        });
      })
      .catch(function () {
        /* 取得失敗時はグリッド空のまま（他ページ機能は無害） */
      })
      .then(init); // 成否に関わらず最後に初期化
  } else {
    init();
  }
})();

/* ============================================================
   シミュレーターバナー（チームオーダー訴求）の自動差し込み
   - 狙いは「複数枚のまとめ注文」。個人1枚より、チーム・部活・サークルの
     まとめ買いに刺さる見出しを HTML 側で持ち、画像はコンテンツページ用の
     静止画バナー（banner_simulator-pages.jpg。文字・ボタン入り）を全幅で出す。
   - 見出し・リードは HTML なのでスマホでも読める（画像内の小さい文字は潰れる前提）。
     ボタンは画像の中にあるので HTML 側には置かない（ボタン2個は迷わせる）。
   - どのページの・どこに・どんな見出しで出すかは PLACEMENTS に1行ずつ。
     目印が見つかった最初の1か所にだけ入れる（1ページ1個）。目印が無い
     ページでは何もしない（全ページ読み込みでも無害）。
   - 商品ページのバナー（1.5節 addSimulatorBanner）は別物。ここでは触らない。
   ============================================================ */
(function () {
  var BANNER_ID = "aw-sim-banner";
  var SIMULATOR_URL = "https://aw-images.artworks-kobe.com/simulator/";
  // コンテンツページ用の静止画（トップの GIF とは別ファイル。Xserver の simulator/banner/）
  var BANNER_IMG =
    "https://aw-images.artworks-kobe.com/simulator/banner/banner_simulator-pages.jpg";
  var BANNER_W = 1801; // 実寸。CSS の width:100%/height:auto と組で表示ズレを防ぐ
  var BANNER_H = 601;
  var BANNER_ALT =
    "AWデザインシミュレーター：デザインしながら金額も確認、枚数割引でチームならもっと安く";

  // 画像の下に小さく出す補足（枚数訴求。根拠は kibako の料金マスタ 1/5/20/50/100枚）
  var POINTS = [
    "5枚・20枚・50枚と枚数が増えるほど1枚あたりが安い",
    "色違い・サイズ別の枚数もまとめて見積もり",
    "デザイン → 見積もり → 決済まで、その場で完結",
  ];

  var DEFAULT_COPY = {
    heading: "チームでおそろい、まとめて見積もり。",
    lead: "人数分の枚数を入れるだけで、金額がその場で分かります。",
  };

  /* ---------- 目印を探す小道具 ---------- */

  // テキストが一致する見出しを返す（空白は無視。startsWith=true なら前方一致）
  function findHeading(root, tag, text, startsWith) {
    var list = root.querySelectorAll(tag);
    for (var i = 0; i < list.length; i++) {
      var t = list[i].textContent.replace(/\s/g, "");
      if (startsWith ? t.indexOf(text) === 0 : t === text) return list[i];
    }
    return null;
  }

  // 見出しの次の H2 までの範囲で selector に合う要素を探す。無ければ範囲の最後の要素。
  function findInSection(heading, selector) {
    var node = heading;
    var last = heading;
    while ((node = node.nextElementSibling)) {
      if (node.tagName === "H2") break;
      if (node.matches && node.matches(selector)) return node;
      last = node;
    }
    return last;
  }

  // 見出しを包んでいる「セクションのかたまり」を返す（親が本文の直下なら親、そうでなければ見出し自身）
  function sectionOf(heading, stopSelector) {
    var p = heading.parentElement;
    if (p && !p.matches(stopSelector) && p.children.length <= 3) return p;
    return heading;
  }

  /* ---------- ページ種別ごとの差し込み先 ----------
     find(doc)  … 目印になる要素を返す（無ければ null）
     where      … 目印に対する位置。afterend / beforebegin / beforeend
     copy       … 見出し・リードの上書き（省略で DEFAULT_COPY） */
  var PLACEMENTS = [
    {
      // 競技ハブ（/pages/swimming 等）: 「オリジナルで作る」のカードの下
      name: "hub",
      where: "afterend",
      find: function (doc) {
        var hub = doc.querySelector(".aw-hub");
        var h = hub && findHeading(hub, "h2", "オリジナルで作る");
        return h && findInSection(h, ".aw-hub-grid");
      },
      copy: {
        heading: "部活・チームのおそろいウェア、まとめて見積もり。",
        lead: "人数分の枚数を入れるだけで、チーム全体の金額がその場で分かります。",
      },
    },
    {
      // 名言・四字熟語などの記事（.aw-article）: 商品セクションの後・編集後記の前
      name: "article",
      where: "beforebegin",
      find: function (doc) {
        return doc.querySelector(".aw-article .closing");
      },
      copy: {
        heading: "この言葉で、チームTシャツを作る。",
        lead: "スローガンや名言を入れて、部活・チームでおそろいに。人数分の金額がその場で分かります。",
      },
    },
    {
      // 競技別オーダーメイド案内（/pages/original-*）: LINE風FAQの前
      name: "original",
      where: "beforebegin",
      find: function (doc) {
        if (!doc.querySelector(".aw-line-chat")) return null;
        var h = findHeading(doc, "h2", "よくある質問");
        return h && sectionOf(h, ".rte");
      },
      copy: {
        heading: "チームの枚数で、いくらになる？",
        lead: "LINEで相談する前に、デザインを置いて人数分の金額を確かめられます。そのまま注文もOK。",
      },
    },
    {
      // 神戸オリジナルTシャツLP（.awk-lp）: 「ご注文の流れ」の前
      name: "kobe-lp",
      where: "beforebegin",
      find: function (doc) {
        var lp = doc.querySelector(".awk-lp");
        var h = lp && findHeading(lp, "h2", "ご注文の流れ", true);
        // 見出しは .awk-section（灰色帯）の中にあるので、帯ごとの前に置く
        return h && (h.closest(".awk-section") || sectionOf(h, ".awk-lp"));
      },
      copy: {
        heading: "チーム・団体の枚数で、その場で見積もり。",
        lead: "部活・サークル・会社のおそろい。デザインを置いて人数分を入れるだけで金額が出ます。",
      },
    },
    {
      // オーダーメイド総合（/pages/ordermade）: 「用途別」の前
      name: "ordermade",
      where: "beforebegin",
      find: function (doc) {
        var h = findHeading(doc, "h2", "用途別");
        return h && (h.closest(".container") || h);
      },
    },
    {
      // AWスポーツウェア総合（/pages/awsports）: 「おすすめ商品」の前
      name: "awsports",
      where: "beforebegin",
      find: function (doc) {
        var h = findHeading(doc, "h2", "おすすめ商品");
        return h && (h.closest(".container") || h);
      },
      copy: {
        heading: "AWのデザインを、チームのおそろいに。",
        lead: "競技別のデザイン集から選んで、チーム名を入れて、人数分の枚数を入れるだけ。",
      },
    },
    {
      // 制作実績ハブ（/pages/works）: 実績グリッドの下
      name: "works",
      where: "afterend",
      find: function (doc) {
        var grid = doc.getElementById("aw-works-grid");
        return grid && (grid.closest(".aw-works") ? grid : null);
      },
      copy: {
        heading: "うちのチームも、こんなウェアを作りたい。",
        lead: "実績のようなチームウェアを、デザインから見積もりまでその場で。人数分の金額がすぐ分かります。",
      },
    },
    {
      // 異名・二つ名ページ（/pages/nickname）: 本文の末尾
      name: "nickname",
      where: "beforeend",
      find: function (doc) {
        if (!/\/pages\/nickname\/?$/.test(location.pathname)) return null;
        return doc.querySelector(".rte");
      },
      copy: {
        heading: "その異名で、チームTシャツを作る。",
        lead: "仲間の異名や通り名を入れて、チームでおそろいに。人数分の金額がその場で分かります。",
      },
    },
  ];

  /* ---------- 見た目 ----------
     記事CSS（.aw-article h3 / p 等）に負けないよう、内側は .aw-sim を前置して詳細度を上げる */
  function injectStyle() {
    if (document.getElementById(BANNER_ID + "-style")) return;
    var style = document.createElement("style");
    style.id = BANNER_ID + "-style";
    style.textContent = [
      ".aw-sim {",
      "  box-sizing: border-box;",
      "  max-width: 820px;",
      "  margin: 32px auto;",
      "  color: #333;",
      "  line-height: 1.6;",
      "}",
      ".aw-hub .aw-sim { margin: 0 0 32px; }", // ハブはグリッド直下なので上余白なし
      ".aw-article .aw-sim { margin: 40px 0 32px; }",
      ".aw-sim .aw-sim__link {", // カード全体がリンク
      "  display: block;",
      "  padding: 16px 16px 14px;",
      "  border: 1px solid #e5e5e5;",
      "  border-radius: 12px;",
      "  background: #f7f7f7;",
      "  color: #333;",
      "  text-decoration: none;",
      "  transition: transform 0.2s, box-shadow 0.2s;",
      "}",
      ".aw-sim .aw-sim__link:hover {",
      "  transform: translateY(-3px);",
      "  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.14);",
      "  color: #333;",
      "  text-decoration: none;",
      "}",
      ".aw-sim .aw-sim__title {",
      "  margin: 0 0 4px;",
      "  padding: 0;",
      "  border: 0;",
      "  color: #222;",
      "  font-size: 19px;",
      "  font-weight: 700;",
      "  line-height: 1.4;",
      "  text-align: center;",
      "}",
      ".aw-sim .aw-sim__lead {",
      "  margin: 0 0 12px;",
      "  color: #555;",
      "  font-size: 14px;",
      "  text-align: center;",
      "}",
      ".aw-sim .aw-sim__img {",
      "  display: block;",
      "  width: 100%;",
      "  height: auto;",
      "  border-radius: 8px;",
      "  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);",
      "}",
      ".aw-sim .aw-sim__points {", // 画像の下に横並びで小さく
      "  display: flex;",
      "  flex-wrap: wrap;",
      "  justify-content: center;",
      "  gap: 2px 14px;",
      "  margin: 10px 0 0;",
      "  padding: 0;",
      "  list-style: none;",
      "  color: #555;",
      "  font-size: 12.5px;",
      "  line-height: 1.5;",
      "}",
      ".aw-sim .aw-sim__points li { margin: 0; padding: 0; }",
      ".aw-sim .aw-sim__points li::before {",
      "  content: '\\2713 ';", // ✓
      "  color: #e85d2c;", // 記事CTAと同じオレンジ
      "  font-weight: 700;",
      "}",
      "@media (max-width: 640px) {",
      "  .aw-sim .aw-sim__link { padding: 12px 12px 10px; }",
      "  .aw-sim .aw-sim__title { font-size: 17px; }",
      "  .aw-sim .aw-sim__lead { font-size: 13px; }",
      "  .aw-sim .aw-sim__points { display: block; text-align: left; font-size: 12px; }",
      "  .aw-sim .aw-sim__points li { margin: 0 0 2px; }",
      "}",
    ].join("\n");
    document.head.appendChild(style);
  }

  function el(tag, className, text) {
    var e = document.createElement(tag);
    if (className) e.className = className;
    if (text) e.textContent = text;
    return e;
  }

  function buildBanner(placement) {
    var copy = placement.copy || DEFAULT_COPY;

    var box = el("div", "aw-sim");
    box.id = BANNER_ID;
    box.setAttribute("data-placement", placement.name);

    var a = el("a", "aw-sim__link");
    a.href = SIMULATOR_URL;
    a.setAttribute("aria-label", "AWデザインシミュレーターでチームの見積もりをする");

    // ページ側の見出し階層を壊さないよう、バナー内は H3 に固定
    a.appendChild(el("h3", "aw-sim__title", copy.heading));
    a.appendChild(el("p", "aw-sim__lead", copy.lead));

    var img = el("img", "aw-sim__img");
    img.src = BANNER_IMG;
    img.alt = BANNER_ALT;
    img.loading = "lazy";
    img.width = BANNER_W;
    img.height = BANNER_H;
    a.appendChild(img);

    var ul = el("ul", "aw-sim__points");
    for (var i = 0; i < POINTS.length; i++) ul.appendChild(el("li", "", POINTS[i]));
    a.appendChild(ul);

    box.appendChild(a);
    return box;
  }

  function run() {
    if (document.getElementById(BANNER_ID)) return; // 二重挿入防止
    for (var i = 0; i < PLACEMENTS.length; i++) {
      var target = PLACEMENTS[i].find(document);
      if (!target) continue;
      injectStyle();
      target.insertAdjacentElement(
        PLACEMENTS[i].where,
        buildBanner(PLACEMENTS[i]),
      );
      return; // 1ページ1個
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
